<template>
  <div class="flex flex-row h-14 sm:h-16">
    <unicon
      name="minus-circle"
      class="w-8 h-8 sm:w-10 sm:h-10 cursor-pointer my-auto text-gray-400 hover:text-gray-600"
      :class="[active ? 'active' : 'notActive']"
      @click="changeValue(-1)"
      v-longclick="() => changeValue(-1)"
    />
    <!-- @click="active ? $emit('update', value - 1) : ''" -->

    <!-- <div class="number text-center leading-none font-medium">
      {{ value }}
    </div> -->

    <input
      type="tel"
      v-model.lazy="valueLocal"
      tabindex="-1"
      class="w-12 number text-center leading-none font-medium bg-transparent"
      @change="setValue(Number(valueLocal))"
    />

    <unicon
      name="plus-circle"
      class="w-8 sm:w-10 h-8 sm:h-10 cursor-pointer my-auto text-gray-400 hover:text-gray-600"
      :class="[active ? 'active' : 'notActive']"
      @click="changeValue(1)"
      v-longclick="() => changeValue(1)"
    />
  </div>
</template>

<script>
import { isEqual } from 'lodash'
export default {
  name: 'InputNumber',
  data() {
    return {
      valueLocal: null
    }
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    value: {
      type: Number,
      required: false,
      default: 0
    },
    maxValue: {
      type: Number,
      required: false,
      default: 150
    },
    minValue: {
      type: Number,
      required: false,
      default: 0
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (!isEqual(this.valueLocal, newValue)) {
          if (typeof newValue === 'number' && !isNaN(newValue))
            this.valueLocal = newValue
        }
      }
    }
  },
  methods: {
    changeValue(amount) {
      this.setValue(this.value + amount)
    },
    setValue(newValue) {
      if (this.active) {
        if (newValue > this.maxValue) newValue = this.maxValue
        if (newValue < this.minValue) newValue = this.minValue
        if (isNaN(newValue)) this.valueLocal = this.value
        else this.$emit('update', newValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.number {
  min-width: 1.25em;
}

.active {
  will-change: opacity;
  opacity: 1;
  //transition: opacity 0.1s 0.2s;
}

.notActive {
  will-change: opacity;
  opacity: 0;
  //transition: opacity 0.01s;
}
</style>
